import { FC } from "react";

interface IProgressBar {
    progressNumber: number;
    totalProgress: number;
}

const ProgressBar: FC<IProgressBar> = ({progressNumber}) => {
    const maxNumberOfBars: number = 3;
    const numberOfInitialBars: number = maxNumberOfBars - progressNumber;

    return (
        <div className={"progress_bar width_100"}>
            {Array.from(Array(progressNumber).keys()).map( (_item: any, index: number) => {
                return <div key={index} className="progress_full_bar"> </div>
            })}
            {Array.from(Array(numberOfInitialBars).keys()).map( (_item: any, index: number) => {
                return <div key={index}  className="progress_empty_bar"> </div>
            })}
        </div>
    )
}

export default ProgressBar;